import {
    FETCH_CHAT_RESTRICTIONS,
    LIST_CHAT_RESTRICTIONS,
    UPDATE_CHAT_RESTRICTION,
    UPDATE_CHAT_RESTRICTION_SUCCESS,
    CLEAR_CHAT_RESTRICTIONS,
    ERROR_CHAT_RESTRICTIONS
} from "./types";

const initialState = {
    isLoading: false,
    list: [],
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 1,
    filter: {}
};

export default (state = initialState, {type, payload}) => {
    switch (type) {
        case FETCH_CHAT_RESTRICTIONS:
            return {
                ...state,
                isLoading: true,
                filter: payload
            };
        case LIST_CHAT_RESTRICTIONS: {
            const dataObj = payload?.data?.data || payload?.data || payload;
            const items =
                dataObj?.items ||
                dataObj?.list ||
                payload?.data?.items ||
                payload?.items ||
                payload?.list ||
                (Array.isArray(dataObj) ? dataObj : Array.isArray(payload) ? payload : []);
            const meta =
                dataObj?.meta ||
                payload?.data?.meta ||
                payload?.meta ||
                dataObj?.paging ||
                payload?.paging ||
                {};
            return {
                ...state,
                isLoading: false,
                list: Array.isArray(items) ? items : [],
                page: meta.page || state.page || 1,
                limit: meta.limit || meta.size || state.limit || 20,
                total: typeof meta.total !== "undefined" ? meta.total : (Array.isArray(items) ? items.length : 0),
                totalPages: meta.totalPages || 1
            };
        }
        case UPDATE_CHAT_RESTRICTION:
            return {
                ...state
            };
        case UPDATE_CHAT_RESTRICTION_SUCCESS: {
            const {userId, shiftCode, isRestricted, shiftCodes} = payload;
            const targetCodes = Array.isArray(shiftCodes)
                ? shiftCodes
                : (shiftCode ? [shiftCode] : []);

            const updatedList = state.list.map(item => {
                if (item.user?.id === userId) {
                    let newTopics = [...(item.topics || [])];
                    if (!isRestricted) {
                        newTopics = newTopics.map(t => {
                            if (!t.shiftCode || t.shiftCode === null) {
                                return {...t, isRestricted: false};
                            }
                            return t;
                        });
                    }
                    targetCodes.forEach(code => {
                        const topicIdx = newTopics.findIndex(t => t.shiftCode === code);
                        if (topicIdx >= 0) {
                            newTopics[topicIdx] = {...newTopics[topicIdx], isRestricted};
                        } else {
                            newTopics.push({shiftCode: code, isRestricted});
                        }
                    });
                    return {
                        ...item,
                        ...(isRestricted ? {} : {isChatRestricted: false, isRestricted: false}),
                        topics: newTopics
                    };
                }
                return item;
            });
            return {
                ...state,
                list: updatedList
            };
        }
        case CLEAR_CHAT_RESTRICTIONS:
            return {
                ...initialState
            };
        case ERROR_CHAT_RESTRICTIONS:
            return {
                ...state,
                isLoading: false
            };
        default:
            return state;
    }
};
